@let valueValue = value();

<rt-input
  #dateDropdownOrigin="rtOverlayOrigin"
  rt-overlay-origin
  class="date-field__input"
  variant="rounded"
  [value]="getSelectedDate(valueValue)"
  [hasDropdownIndicator]="true"
  [readOnly]="true"
  [placeholder]="'app.common.select' | translate"
  (click)="dateDropdown.open = !dateDropdown.open"
  margin-top-small-x
>
  <rt-icon prefix name="calendar-blank" />
</rt-input>

<ng-template
  #dateDropdown="rtConnectedOverlay"
  [origin]="dateDropdownOrigin"
  (backdropClick)="dateDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown (click)="$event.stopPropagation()">
    <rt-dropdown-header>
      {{ 'app.candidate.select_date' | translate }}
    </rt-dropdown-header>
    <rt-date-picker [formControl]="control()" (valueChanged)="dateDropdown.open = false" />
    @if (valueValue) {
      <div layout layout-justify-center layout-align-items-center>
        <div margin-tb-medium>
          <rt-button
            variant="plain"
            (click)="control().setValue(null); dateDropdown.open = false"
            layout-full-width
          >
            <rt-icon name="close" />
            <span class="label">{{ 'app.common.clear' | translate }}</span>
          </rt-button>
        </div>
      </div>
    }
  </rt-dropdown>
</ng-template>
